import React from 'react'
import { withTranslation } from 'react-i18next'
import { LoadingSpinner } from 'pyrexx-react-library'

const Loading = (props) => {
  return <LoadingSpinner message={props.t('LOADING')} />
}
export default withTranslation('translation')(Loading)
